import {
  Component,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Capacitor, PluginListenerHandle } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";

@Component({
  standalone: true,
  imports: [TranslateModule, LucideAngularModule],
  selector: "app-dialog-overlay",
  templateUrl: "./dialog-overlay.component.html",
})
export class DialogOverlayComponent implements OnInit, OnDestroy {
  constructor(private ngZone: NgZone) {}

  @Output() closed = new EventEmitter<boolean>();

  protected keyboardHeight = 0;
  private keyboardShowHandle?: PluginListenerHandle;
  private keyboardHideHandle?: PluginListenerHandle;

  async ngOnInit() {
    if (Capacitor.getPlatform() === "web") return;

    this.keyboardShowHandle = await Keyboard.addListener(
      "keyboardWillShow",
      (info) => {
        this.ngZone.run(() => {
          this.keyboardHeight = info.keyboardHeight;
        });
      },
    );
    this.keyboardHideHandle = await Keyboard.addListener(
      "keyboardWillHide",
      () => {
        this.ngZone.run(() => {
          this.keyboardHeight = 0;
        });
      },
    );
  }

  ngOnDestroy() {
    this.keyboardShowHandle?.remove();
    this.keyboardHideHandle?.remove();
  }

  ignoreParentClick(e: Event) {
    e.stopPropagation();
  }
}
